import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/profile";
import LeafDateTime from "../../../../common/leaf/LeafDateTime/LeafDateTime";
import "./RecentOrderDateInfo.scss";

type Props = {
  date: string;
  privacyFlag?: boolean;
  show?: boolean;
};

const RecentOrderDateInfo = (props: Props) => {
  const { date, privacyFlag, show } = props;
  const { t } = useTranslation(["profile"]);

  const renderInfo = date ? (
    <LeafDateTime date={date} options={{ month: "long", day: "numeric", year: "numeric" }} ignoreTimeZone={true} />
  ) : (
    `${t("aboProfile.datesTab.noRecentOrderDate", defaultContent["aboProfile"]["datesTab"]["noRecentOrderDate"])}`
  );

  const privacyView = privacyFlag === true ? "-" : renderInfo;

  if (show === true) {
    return (
      <div className="leaf-recent-order">
        <div className="leaf-recent-order__container">
          <div className="leaf-recent-order__content-title">
            {`${t("aboProfile.datesTab.recentOrderDate", defaultContent["aboProfile"]["datesTab"]["recentOrderDate"])}`}
          </div>
          <div className="leaf-recent-order__content-data">{privacyView}</div>
        </div>
      </div>
    );
  }

  return <></>;
};

export default RecentOrderDateInfo;
